import React from 'react'
import { createHashRouter, Navigate } from 'react-router-dom'
import Loading from '@/components/Loading'
import { Layout, NoAuth, Index, Djzp, Bidregister } from './pageArr'

const withLoadingComponent = (comp) => <React.Suspense fallback={<Loading />}>{comp}</React.Suspense>

// hash 模式
const router = createHashRouter([
  {
    path: '/',
    element: <Layout />,
    children: [
      {
        index: true,
        element: withLoadingComponent(<Index />)
      },
      {
        path: 'index',
        element: withLoadingComponent(<Index />)
      },
      {
        path: 'djzp',
        element: withLoadingComponent(<Djzp />)
      },
      {
        path: 'bidregister',
        element: withLoadingComponent(<Bidregister />)
      }
    ]
  },
  {
    path: '404',
    element: withLoadingComponent(<NoAuth type="404" />)
  },
  {
    path: 'noAuth',
    element: withLoadingComponent(<NoAuth />)
  },
  {
    path: '*',
    element: <Navigate to="/404" />
  }
])

export default router
